import { render, staticRenderFns } from "./ArquivosFornecedorTabela.vue?vue&type=template&id=cc9e7e90"
import script from "./ArquivosFornecedorTabela.vue?vue&type=script&lang=js"
export * from "./ArquivosFornecedorTabela.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports